module.exports = __webpack_public_path__ + "static/media/menuWorkflow.d6728beb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuWorkflow.svg
// module id = 489
// module chunks = 0